export default __webpack_public_path__ + "media/images/features/local_delivery/episode6/LP_03-bc5b94932e6b886a0fa3e95349e449a7.jpeg";